import { db } from "../../firebase";
import { USERS, REFERS } from "../Collections";

const refersRef = uid => db.collection(`${USERS}/${uid}/${REFERS}`);

export const getAll = uid => refersRef(uid);
